import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import CampaignGroupFilterItem from "../items/CampaignGroupFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "CampaignFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    CampaignGroupFilterItem,
    ListSection
  },
  emits: ["clear", "discard", "restoreSearch", "select", "deselect", "selectAll", "apply", "search", "hidden", "closeDropdown", "selectOnly"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    }
  },
  computed: {
    getListTitle() {
      return this.searching ? `${this.list.length} CAMPAIGNS FOUND` : "CAMPAIGNS";
    }
  }
};